import { useMemo } from 'react';

import { TaskActivity } from '@/v2/domains/Tasks/types/task';
import getMiniactivityConf from '@/modules/tasks/getMiniactivityConf';
import { getActivityConf } from '@/modules/activities/ActivityTypesConf';
import useGetActivityQuery from '@/v2/domains/Activities/queries/useGetActivityQuery.hook';
import useReinforcementActivity from '@/v2/domains/Student/Tasks/hooks/useReinforcementActivity.hook';

export default function useTaskActivityConf(taskActivity: TaskActivity) {
  const { data: loadedActivity, isLoading } = useGetActivityQuery({
    activityId: taskActivity?.activityId,
  });

  const { activity, isLoading: isLoadingReinforcement } =
    useReinforcementActivity({ taskActivity, activity: loadedActivity });

  const activityConf = useMemo(() => {
    if (!taskActivity || !activity) {
      return null;
    }

    const taskActivityConf = taskActivity.activityConf.miniactivities
      ? taskActivity.activityConf.miniactivities[0]
      : taskActivity.activityConf;

    const miniactivityConf = getMiniactivityConf(taskActivityConf);

    return getActivityConf({
      miniactivityConf,
      type: activity.type,
      subType: activity.data?.subType,
    });
  }, [activity, taskActivity]);

  return {
    activity,
    activityConf,
    taskActivityConf: taskActivity?.activityConf,
    isLoading: isLoading || isLoadingReinforcement || !taskActivity?.activityId,
  };
}
